import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import RolesList from './components/roles-list';
import UsersList from './components/users-list';

/**
 * User Management page function component
 */
function UserManagement() {
  const { currentPage } = useParams<{ currentPage: string }>();
  const [openTab, setOpenTab] = useState(currentPage === 'user' ? 0 : 1);

  /**
   * Completed the add and update task
   * @param message
   */
  // const completedTask = (message: string, type: string) => {
  //   if (type === 'role') {
  //     dispatch(
  //       fetchAllRoles({
  //         page: DefaultApiParameters.page,
  //         limit: DefaultApiParameters.limit,
  //       }),
  //     );
  //   }
  //   if (type === 'user') {
  //     dispatch(
  //       fetchAllUsers({
  //         page: DefaultApiParameters.page,
  //         limit: DefaultApiParameters.limit,
  //       }),
  //     );
  //   }
  //   setOpenStatus(true);
  //   setModalView({
  //     title: '',
  //     header: false,
  //     content: (
  //       <SuccessNotification
  //         title={message}
  //         description=""
  //         notificationCloseTimer={3000}
  //         onNotificationClose={closeModal}
  //       />
  //     ),
  //     rightCorner: '',
  //     notification: true,
  //   });
  // };
  useEffect(() => {
    if (currentPage === 'user') {
      setOpenTab(0);
    } else if (currentPage === 'role') {
      setOpenTab(1);
    }
  }, [currentPage]);

  return (
    <div className="user-role-management-wrap">
      <div className="user-role-management-container">
        <div className="table-content">
          {openTab === 0 && <UsersList />}
          {openTab === 1 && <RolesList />}
        </div>
      </div>
    </div>
  );
}

export default UserManagement;
